import CallToAction from "./CallToAction";
import compose from "recompose/compose";
import withProps from "recompose/withProps";
import formatPrismicData from "../../hocs/formatPrismicData";
import { localiseUrlII } from "src/common/utils/format-localised-url";
import withCountry from "../../hocs/withCountry";

const enhance = compose(
  formatPrismicData,
  withCountry,
  withProps((props) => ({
    ctaLink: localiseUrlII(props.country, props.ctaLink),
  }))
);

export default enhance(CallToAction);
